/**
 * Sentry ErrorBoundary fallback — themed, minimal copy per CLAUDE.md (CSS variables).
 */
export function ErrorFallback({ error }: { error: Error }) {
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="themed-surface max-w-xl rounded-xl p-6 text-center">
        <h1 className="text-xl font-semibold text-[var(--foreground)]">Something went wrong</h1>
        <p className="mt-2 text-sm text-[var(--muted-foreground)]">
          The page hit an unexpected error. You can refresh or return to Dashboard.
        </p>
        {error.message && (
          <p className="mt-3 text-xs text-[var(--muted-foreground)]">{error.message}</p>
        )}
        <div className="mt-4 flex justify-center gap-2">
          <button
            type="button"
            className="rounded-md border border-[var(--border)] px-3 py-2 text-sm"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
          <a
            href="/"
            className="rounded-md bg-[var(--primary)] px-3 py-2 text-sm font-medium text-[var(--primary-foreground)]"
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    </main>
  );
}
